import { useEffect } from 'react';

interface UsePollingUntilReadyOptions {
  isReady: boolean;
  enabled?: boolean;
  pollFn: () => void;
  onTimeout?: () => void;
  pollInterval?: number;
  timeoutDuration?: number;
}

export function usePollingUntilReady({
  isReady,
  enabled = true,
  pollFn,
  onTimeout,
  pollInterval = 2000,
  timeoutDuration = 30000,
}: UsePollingUntilReadyOptions) {
  useEffect(() => {
    if (isReady || !enabled) return;

    const interval = setInterval(() => {
      pollFn();
    }, pollInterval);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      if (onTimeout) onTimeout();
    }, timeoutDuration);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [isReady, pollFn, pollInterval, timeoutDuration, enabled, onTimeout]);
}
